// frontend/src/pages/CustomerMessages.tsx
import React from 'react';

const CustomerMessages: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Messages</h1>
      <p>Communication with service providers.</p>
    </div>
  );
};

export default CustomerMessages;